(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.service('vvDimension', ['$window', function($window) {
    this.getScrollOffsets = function(el) {
      //console.log('getScrollOffsets', 'scrollTop', el.scrollTop, 'offsetHeight', el.offsetHeight, 'innerHeight', el.innerHeight, 'scrollHeight', el.scrollHeight);
      var css = $window.getComputedStyle(el);
      var top = el.scrollTop;
      var bottom = el.scrollHeight - el.scrollTop - el.offsetHeight + parseInt(css.borderTopWidth) + parseInt(css.borderBottomWidth);
      return { top: top, bottom: bottom };
    };

    this.isFullyVisible = function(el) {
      var elemTop = el.getBoundingClientRect().top;
      var elemBottom = el.getBoundingClientRect().bottom;
      var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
      return isVisible;
    };
  }]);
})(window, window.angular);
